"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerStyles = void 0;
const lit_1 = require("lit");
exports.footerStyles = (0, lit_1.css) `
  :host {
    display: block;
  }

  .footer {
    padding: 2rem var(--layout-padding-inline);
    padding-left: var(--sidebar-content-shift);
    margin: 0 auto;
    position: relative;
    transition: padding-left var(--transition-duration) var(--transition-easing);
  }

  .footer address mm-paragraph {
    margin: var(--space-4) 0;
  }

  .footer-links {
    display: flex;
    flex-direction: column;
    max-width: var(--layout-width-narrow);
    margin: var(--space-4) 0;
  }

  .footer-address-break {
    width: 100%;
  }

  .footer-address-info {
    display: flex;
    flex-wrap: wrap;
    column-gap: var(--space-2);
  }

  .footer-address-info dt {
    color: var(--foreground-subtle-color);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9vdGVyLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZvb3Rlci5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXlCO0FBRVosUUFBQSxZQUFZLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FxQzlCLENBQUEifQ==